import React from 'react'
import styled from '@emotion/styled'
import BaseRadio from './radio'

const Container = styled.div`
  display: flex;
`

const Radio = styled(BaseRadio)`
  & + & {
    margin-left: ${p => p.theme.space[5]};
  }
`

const RadioGroup = ({ onChange, items = [], selected, className }) => (
  <Container className={className}>
    {items.map(({ value, label }, index) => (
      <Radio
        value={value}
        checked={selected === value}
        onChange={() => onChange(value)}
        key={index}
      >
        {label}
      </Radio>
    ))}
  </Container>
)

export default RadioGroup
